/* --------------
swipers obserwer
-------------- */

function loadScript(src) {
    return new Promise(resolve => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        document.body.appendChild(script);
    });
}

function loadCSS(href) {
    return new Promise(resolve => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        link.onload = resolve;
        document.head.appendChild(link);
    });
}

let swiperLoaded = false;

const swiperTargets = [
    "#team-section",
    "#swiper-quotations"
];

const observer = new IntersectionObserver(async (entries) => {
    for (const entry of entries) {
        if (entry.isIntersecting && !swiperLoaded) {
            
            swiperLoaded = true;
            await loadCSS("/wp-content/themes/kptsnew/dist/assets/css/swiper-bundle.min.css");
            await loadScript("/wp-content/themes/kptsnew/dist/assets/js/swiper-bundle.min.js");

            initSwiperTeam();
            initSwiperQuotations();

            observer.disconnect();
        }
    }
}, { threshold: 0.1 });

swiperTargets.forEach(sel => {
    const el = document.querySelector(sel);
    if (el) observer.observe(el);
});

// team-swiper
let swiperTeam = null;

function initSwiperTeam() {
    if (window.innerWidth > 766.9 && !swiperTeam) {
        swiperTeam = new Swiper("#swiper-team", {
            slidesPerView: 4,
            spaceBetween: 32,
            mousewheel: {
                enabled: true,
                releaseOnEdges: true,
            },
            breakpoints: {
                0: {
                slidesPerView: 2,
                spaceBetween: 16,
                },
                1024: {
                slidesPerView: 3,
                spaceBetween: 32,
                },
                1439: {
                slidesPerView: 4,
                }
            }
        });
    } else if (window.innerWidth <= 767 && swiperTeam) {
        swiperTeam.destroy(true, true);
        swiperTeam = null;
    }
}

// document.addEventListener('DOMContentLoaded', initSwiperTeam);
window.addEventListener('resize', initSwiperTeam);

// quotations-swiper
function initSwiperQuotations() {
    const swiper = new Swiper("#swiper-quotations", {
        loop: true,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        // mousewheel: true,
        keyboard: true,
    });

    function restartProgress() {
        document.querySelectorAll('.swiper-pagination-bullet').forEach(b => {
            b.classList.remove('is-progress');
            void b.offsetWidth;
        });
        const active = document.querySelector('.swiper-pagination-bullet-active');
        if (active) active.classList.add('is-progress');
    }

    swiper.on('slideChangeTransitionStart', restartProgress);
    restartProgress();
}